module.exports = __webpack_public_path__ + "plaquedefense_example.aed7e4a10e5e1f63f5fd.png";


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/assets/images/orthokit/plaquedefense_example.png
// module id = ../../../../../src/assets/images/orthokit/plaquedefense_example.png
// module chunks = main